import styled from '@emotion/styled';

type CardsContainereProps = {
  isInContainer?: boolean;
};

export const CardsContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isInContainer',
})<CardsContainereProps>`
  margin: ${(props) => props.isInContainer && 'auto'};
`;
